import React from "react";
import { Grid } from "@mui/material";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import LabeledSelect from "../../Widgets/LabeledSelect";
import { SleepProfileFormValues } from "./interface";

const YES_NO_OPTIONS = [
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
];

interface EditFieldsProps {
  formValues: SleepProfileFormValues;
  handleChange: (
    field: keyof SleepProfileFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledTextArea
        multiline
        label="Notable sleep concerns"
        value={formValues.notableSleepConcerns}
        onChange={handleChange("notableSleepConcerns")}
      />
      <LabeledTextArea
        multiline
        label="Bedtime routine"
        value={formValues.bedtimeRoutine}
        onChange={handleChange("bedtimeRoutine")}
      />
      <LabeledSelect
        label="Does the client sleep throughout the night?"
        value={formValues.sleepsThroughNight}
        onChange={handleChange("sleepsThroughNight")}
        options={YES_NO_OPTIONS}
      />
      <LabeledSelect
        label="Does the client take naps regularly?"
        value={formValues.takesNapsRegularly}
        onChange={handleChange("takesNapsRegularly")}
        options={YES_NO_OPTIONS}
      />
      <LabeledSelect
        label="If they wake up, do they get out of bed?"
        value={formValues.wakesAndGetsOut}
        onChange={handleChange("wakesAndGetsOut")}
        options={YES_NO_OPTIONS}
      />
      <LabeledSelect
        label="If they wake up, do they seek out an adult?"
        value={formValues.wakesAndSeeksAdult}
        onChange={handleChange("wakesAndSeeksAdult")}
        options={YES_NO_OPTIONS}
      />
    </Grid>
  );
};

export default EditFields;
